import { FormikErrors } from 'formik'

import { required } from '../../_utils/formValidators'
import { LocationScopeInfoValues } from './LocationScope.view'

const validateLocationScope = (locationScope: string) => {
  return required.default(locationScope)
}

const validatePercentageOutsideCH = (
  locationScope: string,
  percentageOutsideCH: string,
) => {
  return locationScope === 'europe'
    ? required.default(percentageOutsideCH)
    : undefined
}

export const validateFieldForm = (formValueFields: LocationScopeInfoValues) => {
  const errors: FormikErrors<LocationScopeInfoValues> = {}

  if (validateLocationScope(formValueFields.locationScope)) {
    errors.locationScope = validateLocationScope(formValueFields.locationScope)
  }

  if (
    validatePercentageOutsideCH(
      formValueFields.locationScope,
      formValueFields.percentageOutsideCH,
    )
  ) {
    errors.percentageOutsideCH = validatePercentageOutsideCH(
      formValueFields.locationScope,
      formValueFields.percentageOutsideCH,
    )
  }

  return errors
}
